function triggerBagPulse() {
  const bagIcon = document.querySelector('a[aria-label="Bag"]');
  if (!bagIcon) return;
  bagIcon.classList.remove('ribble-bag-pulse');
  void bagIcon.offsetWidth;
  bagIcon.classList.add('ribble-bag-pulse');
  bagIcon.addEventListener('animationend', () => {
    bagIcon.classList.remove('ribble-bag-pulse');
  }, { once: true });
}


function ulHeight (container, rM) {
  theme.ulHeight = container.querySelector('.main-menu .customer-links').offsetHeight;
  rM.style.maxHeight = (theme.height - theme.ulHeight - 40) + 'px';
};
function MenuHeight (container) {
  var hdr = document.getElementById('header-toolbar'),
      stky = hdr.getAttribute('data-sticky');
  if (stky == 'true') {
    document.selectors = {
      sht: hdr.offsetHeight
    };
  } else {
    document.selectors = {
      sht: 0
    };
  };
  document.querySelector('html').style.scrollPaddingTop = document.selectors.sht + 'px';
  const iH = theme.height;
  const sN = container.querySelector('.sticky-navigation-container');
  const sNH = sN.offsetHeight;
  var cD = document.querySelector('#cart-dropdown span'),
      rM = container.querySelector('.responsiveMenu');
  if (cD) {
    var cDl = document.querySelector('#cart-dropdown .buttons').offsetHeight;
    if (theme.width <= theme.breakpoint_margin) {      
      cD.style.maxHeight = (iH - sNH - cDl - 30) + 'px';
    } else {
      cD.style.maxHeight = (iH - sNH - cDl) / 2 + 'px';
    }
  }  
  if (theme.mobile == false) {
    var pLu = rM.querySelectorAll('.parent-level-ul');
    pLu.forEach(function(p) {
      if (p) {
        p.style.setProperty('--max-height', iH - hdr.offsetHeight - 40 + 'px');
      }
    });  
  }
};
theme.Header = (function() {
  function Header(container) {
    var sectionId = container.getAttribute('data-section-id'),
        dD = container.getAttribute('data-dropdown'),
        t = container.querySelector('.toggleMenu'),
        r = container.querySelector('.responsiveMenu'),
        sN = container.querySelector('.sticky-navigation'),
        sNB = sN.getAttribute('data-border'),
        hNW = document.getElementById('header-navigation-width'),
        cCM = document.getElementById('cart-count-mobile'),
        cCMa = cCM.querySelector('.cart-count-mobile'),
        cCMb = container.querySelector('#cart-dropdown .modal-close'),
        m = container.getAttribute('data-multi'),
        pS = JSON.parse(document.getElementById('shopify-features').textContent),
        iH = theme.height,
        mmCL = container.querySelector('.main-menu .customer-links'),
        k = container.querySelectorAll('.header-customerbar .customer-links .keydown');
    function menuWidth() {      
      const pL = document.querySelectorAll('.visually-hidden .visually-hidden-links');
      theme.nW = 0;
      pL.forEach(function(p) {
        theme.nW += p.offsetWidth + 5;
      });
    }
    if(dD == 'true'){
      theme.dropdown = true;
    } else {
      theme.dropdown = false;
    }
    theme.cart = false;    
    function menuAdjust() {
      var iW = theme.width,
          nW = theme.nW,
          mMW = theme.breakpoint_margin,
          tW = container.querySelector('#header-navigation .header-navigation-measure').offsetWidth - parseInt(container.getAttribute('data-logo-width'));
      if (nW > tW) {
        theme.updateNav = true;
      } else {
        theme.updateNav = false;
      };
      var tM = document.querySelector('.toggleMenu'),
          rM = document.querySelector('.responsiveMenu'),
          cD = document.getElementById('cart-dropdown'),
          cCM = document.getElementById('cart-count-mobile'),
          cCD = document.getElementById('cart-count-desktop'),
          rMl = rM.querySelectorAll('li');
      if (iW <= mMW) {
        if (cD) {
          cCM.appendChild(cD);
        };
      } else {
        if (cD) {
          cCD.appendChild(cD);
        };
      };
      if (iW <= mMW || theme.updateNav || theme.detectmob) {
        tM.classList.remove('isDesktop');
        tM.classList.add('isMobile');
        rM.classList.remove('isDesktop');
        rM.classList.add('isMobile');
        var pLu = rM.querySelectorAll('.parent-level-ul');
        pLu.forEach(function(p) {
          p.removeAttribute('style');
          if (p.querySelector('li')) {
            p.querySelector('li').setAttribute('aria-popup','true');
            p.querySelector('li').setAttribute('aria-expanded','false');
          }      
        });
        rMl.forEach(function(r) {
          r.onmouseenter = function(ev){
            return false;
          };      
          r.onmouseleave = function(ev){
            return false;
          };
          r.classList.remove('isDesktop');
          r.classList.add('isMobile');
        });
        var rMp = rM.querySelectorAll('li.has-dropdown a.parent');
        rMp.forEach(function(r) {          
          r.onclick = function(ev){
            var pE = r.parentElement,
                pEuL = pE.querySelector('ul');
            if((r.getAttribute('href') != 'undefined') && r.getAttribute('href') != '#' && ev.target.matches('span')){   
            } else {
              ev.preventDefault();
              pEuL.style.setProperty('--max-height', pEuL.scrollHeight + 'px');
              if (pE.classList.contains('child-level')) {
                var h = pE.closest('.parent-level-ul').scrollHeight;
                pE.closest('.parent-level-ul').style.setProperty('--max-height', (pEuL.scrollHeight + h) + 'px');
              }
              pE.classList.toggle('hover');
              pE.setAttribute('aria-expanded', 
                pE.getAttribute('aria-expanded') === 'true' 
                  ? 'false' 
                  : 'true'
              );
            }
          };
        });
        document.body.classList.remove('desktop-only');
        document.body.classList.add('mobile-only');
        theme.mobile = true;
      } else if (iW > mMW) {
        var hoverTimeout;    
        tM.classList.remove('isMobile');
        tM.classList.add('isDesktop');
        rM.classList.remove('isMobile');
        rM.classList.add('isDesktop');
        var pLu = rM.querySelectorAll('.parent-level-ul');
        pLu.forEach(function(p) {
          if (p.querySelector('li')) {
            p.querySelector('li').removeAttribute('aria-popup');
            p.querySelector('li').removeAttribute('aria-expanded');
          }
        });
        rMl.forEach(function(r) {
          r.classList.remove('hover','isMobile');
          r.classList.add('isDesktop');
        });
        function open(r) {
          var rMh = rM.querySelectorAll('li.hover');
          rMh.forEach(function(r) {
            r.classList.remove('hover');
            r.setAttribute('aria-expanded','false');
          });
          clearTimeout(hoverTimeout);
          r.classList.add('hover');
          r.setAttribute('aria-expanded','true');          
        }
        function close(r) {
          hoverTimeout = setTimeout(function() {
            r.classList.remove('hover');
            r.setAttribute('aria-expanded','false');
          },250);
        }
        var rMp = rM.querySelectorAll('li.parent');
        rMp.forEach(function(r) {         
          r.addEventListener('keydown', function(ev) {
            r.classList.add('focused');
          });          
          r.querySelector('a.parent').onblur = function(ev){
            r.classList.remove('focused');
          }
          r.querySelector('a.parent').onclick = function(ev){
            if (r.classList.contains('focused')) {
              ev.preventDefault();
            }
            if (r.classList.contains('hover')) {
              close(r);
            } else {
              open(r);                
            }
          };
          r.onmouseenter = function(ev){
            open(r);
          };
          r.onmouseleave = function(ev){
            close(r);
          };
        });
        document.body.classList.remove('mobile-only');
        document.body.classList.add('desktop-only');
        theme.mobile = false;
      }
    }
    if (location.pathname == '/challenge') {
      window.location.hash = '';
      window.scrollTo(0, 0);      
    } else if (window.location.hash) {
      setTimeout(function () {
        var hsh = location.hash;
        var hc = document.querySelector(hsh);
        if (!hc) {
          return;
        }
        var s = hc.getBoundingClientRect().top + window.pageYOffset;
        window.scrollTo({top:s-document.selectors.sht, behavior: 'smooth'});
      }, 1);
    } else if (window.location.href.indexOf('customer_posted') > -1 || window.location.href.indexOf('contact?contact_posted') > -1) {
      if (document.cookie.split('AveForm=popUp').length == 1) {
        MenuHeight(container,theme.mobile);
        var fb = document.querySelector('.feedback'); 
        if (!fb) {
          return; 
        }
        var s = fb.getBoundingClientRect().top + window.pageYOffset;
        window.scrollTo({top:s-document.selectors.sht, behavior: 'smooth'});
      }
    }
    function menu_open(r) {
      t.classList.add('active');
      document.body.classList.add('modal-active');        
      r.classList.add('open');        
      t.parentElement.setAttribute('aria-expanded','true');      
      setTimeout(function() {
        ulHeight(container, r);  
        trapFocus(sN); 
      }, 1);      
      sN.style.height = (sN.getBoundingClientRect().height - parseInt(sNB)) + 'px';     
      document.body.classList.add('no-scroll');
    };
    function menu_close(r) {
      t.classList.remove('active');
      document.body.classList.remove('modal-active');
      r.classList.remove('open');
      t.parentElement.setAttribute('aria-expanded','false');
      document.body.classList.add('clear-scroll');
      removeTrapFocus(sN);
      document.body.classList.remove('no-scroll');
      setTimeout(function() {
        document.body.classList.remove('clear-scroll');
      }, 500);
    };    
    t.onclick = function(ev){
      if (!r.classList.contains('open')) {
        menu_open(r);        
      } else {
        menu_close(r);
      };
      if (theme.detectmob) {
        document.body.classList.remove('cart-open');
      }
      cCM.classList.remove('hover');
      if (cCMb && document.getElementById('cart-dropdown')) {
        container.querySelector('#cart-dropdown .modal-close').classList.add('hidden');
      }    
    }
    function open(r) {
      var l = container.querySelectorAll('.header-customerbar .customer-links li.hover');
      l.forEach(function(r) {
        r.classList.remove('hover');
        r.setAttribute('aria-expanded','false');
      });
      r.classList.add('hover');
      r.setAttribute('aria-expanded','true'); 
    }
    function close(r) {
      r.classList.remove('hover');
      r.setAttribute('aria-expanded','false');
    }
    k.forEach(function(r) {
      r.addEventListener('keydown', function(ev) {
        r.classList.add('focused');
      });          
      r.querySelector('.keydown-link').onblur = function(ev){
        r.classList.remove('focused');
      }
      r.querySelector('.keydown-link').onclick = function(ev){
        if (r.classList.contains('focused')) {
          ev.preventDefault();
        }
        if (r.classList.contains('hover')) {
          close(r);
        } else {
          open(r);
        }
      };
      r.onmouseenter = function(ev){
        open(r);
      };
      r.onmouseleave = function(ev){
        close(r);
      };
    });
    if(theme.dropdown == true){        
      cCMa.onclick = function(ev){
        if (theme.detectmob) {
          document.body.classList.toggle('cart-open');
        }
        cCM.classList.toggle('hover');
        if (cCMb && document.getElementById('cart-dropdown')) {
          container.querySelector('#cart-dropdown .modal-close').classList.add('hidden');
        }
      }
    };
    function wS() {
      menuAdjust();
      sN.style.height = '';
      if (r.classList.contains('open')) {
        menu_close(r);
      };
    }
    var cW = window.innerWidth;
    window.addEventListener('resize', function() {
      theme.height = window.innerHeight;
      MenuHeight(container,theme.mobile);
      if (cW == window.innerWidth) {
        return;
      }
      cW = window.innerWidth;
      wS();   
    });
    menuWidth();
    menuAdjust();
    MenuHeight(container,theme.mobile);    
    theme.multiHead = m;
    if (theme.multiHead == 'true') {
      Multi();
    }
    var el = document.querySelector('.search details');
    if (el) {
      el.onclick = function(e){
        var moR = container.querySelector('.mobile-only .responsiveMenu');
        if(theme.width <= theme.breakpoint_margin){
          var dd = document.getElementById('cart-count-mobile');
        } else {
          var dd = document.getElementById('cart-count-desktop');
        }
        dd.classList.remove('hover');
        dd.classList.add('avoid');
        var ddC = dd.querySelector('.modal-close');
        if (ddC) {
          ddC.classList.add('hidden');
        }
        setTimeout(function() {
          dd.classList.remove('avoid');
        }, 1);
        if(t.classList.contains('active')) {
          t.classList.remove('active');          
          moR.classList.remove('open');
          moR.classList.remove('active');
          document.body.classList.remove('no-scroll');
          document.body.classList.remove('modal-active');
          document.body.style.position = '';
          document.body.style.left = 'auto';
          document.body.style.right = 'auto';
          document.body.style.top = 'auto';
        }
        var li = el.closest('li'),
            d = li.querySelector('details'),
            mC = li.querySelector('.search-modal'),
            hS = li.querySelector('.header-searchbar');
            sF = hS.querySelector('.search-field');        
        function openSearch(e) {
          sF.value = '';
          sF.disabled = false;
          mC.classList.remove('hidden');
          trapFocus(li);
          sF.focus();
        }            
        function closeSearch(e) {
          sF.value = '';
          sF.disabled = true;
          d.open = false;
          mC.classList.add('hidden');
          sF.blur();
          removeTrapFocus(li);
        }
        mC.onclick = function(e){          
          closeSearch(e)
        }
        setTimeout(function () {
          if (el.hasAttribute('open')) {
            openSearch(e);
          } else {
            closeSearch(e);
          }
        }, 250);
      };
    };
    if(container.getAttribute('data-search') == 'true'){
      function debounce(fn, wait) {
        let t;
        return (...args) => {
          clearTimeout(t);
          t = setTimeout(() => fn.apply(this, args), wait);
        };
      }
      class PredictiveSearch extends HTMLElement {
        constructor() {
          super();
          this.cachedResults = {};
          this.input = this.querySelector('input[type="search"]');
          this.predictiveSearchResults = this.querySelector('[data-predictive-search]');
          this.animate = this.closest('.animate-section');
          this.predictiveSearchResultsTop = this.getBoundingClientRect().top;
          this.isOpen = false;
          this.setupEventListeners();
        }
        setupEventListeners() {
          const form = this.querySelector('form.search');    
          form.addEventListener('submit', this.onFormSubmit.bind(this));
          this.input.addEventListener('input', debounce((event) => {            
            this.onChange(event);
          }, 300).bind(this));
          this.input.addEventListener('focus', this.onFocus.bind(this));
          this.addEventListener('focusout', this.onFocusOut.bind(this));
        }
        getQuery() {
          return this.input.value.trim();
        }
        onChange() {
          const searchTerm = this.getQuery();
          if (!searchTerm.length) {
            this.close(true);
            return;
          }
          this.getSearchResults(searchTerm);
        }
        onFormSubmit(event) {
          if (!this.getQuery().length || this.querySelector('[aria-selected="true"] a')) event.preventDefault();
        }
        onFocus() {
          document.querySelector('html').style.scrollPaddingTop = 0;
          const searchTerm = this.getQuery();
          if (!searchTerm.length) return;
          if (this.getAttribute('results') === 'true') {
            this.open();
          } else {
            this.getSearchResults(searchTerm);
          }          
        }
        onFocusOut() {
          document.querySelector('html').style.scrollPaddingTop = document.selectors.sht + 'px';          
          setTimeout(() => {if (!this.contains(document.activeElement)) this.close();})    
        }
        getSearchResults(searchTerm) {
          const queryKey = searchTerm.replace(" ", "-").toLowerCase();
          if (this.cachedResults[queryKey]) {
            this.renderSearchResults(this.cachedResults[queryKey]);
            return;
          }
          const search_limit = this.predictiveSearchResults.getAttribute('data-search-limit');
          const search_fields = this.predictiveSearchResults.getAttribute('data-search-fields');
          if (pS.predictiveSearch ==  true) {
            var URL = theme.routes_predictive_search_url + '?&q=' + encodeURIComponent(searchTerm) + '&section_id=predictive-search&' + encodeURIComponent('resources[fields]') + '=' + search_fields + '&' + encodeURIComponent('resources[limit]') + '=' + search_limit;
          } else {
            var URL = theme.routes_search_url + '?&q=' + encodeURIComponent(searchTerm) + '&section_id=predictive-search&options[prefix]=last';
          }
          fetch(URL)
          .then((response) => {
            if (!response.ok) {
              var error = new Error(response.status);
              this.close();
              throw error;
            }
            return response.text();
          })
          .then((text) => {
            const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
            this.cachedResults[queryKey] = resultsMarkup;
            this.renderSearchResults(resultsMarkup);
          })
          .catch((error) => {
            this.close();
            throw error;
          });
        }
        renderSearchResults(resultsMarkup) {
          this.predictiveSearchResults.innerHTML = resultsMarkup;
          const btn = this.querySelector('.modal-close');
          const ps = this;
          btn.addEventListener('keydown', e => {
            if (e.key === 'Enter') {
              ps.close();
            }
          });
          btn.addEventListener('click', function(ev) {
            ps.close();
          }, false);
          this.setAttribute('results', true);
          this.setLiveRegionResults();
          this.open();
        }
        setLiveRegionResults() {
          this.removeAttribute('loading');
        }
        getResultsMaxHeight() {
          this.resultsMaxHeight = theme.height - this.getBoundingClientRect().top - 80;
          return this.resultsMaxHeight;
        }
        open() {
          if(theme.width <= theme.breakpoint_margin){
            var dd = document.getElementById('cart-count-mobile');
          } else {
            var dd = document.getElementById('cart-count-desktop');
          }
          dd.classList.remove('hover');
          dd.classList.add('avoid');
          var ddC = dd.querySelector('.modal-close');
          if (ddC) {
            ddC.classList.add('hidden');
          };
          setTimeout(function() {
            dd.classList.remove('avoid');
          }, 1);
          var height = this.resultsMaxHeight || `${this.getResultsMaxHeight()}`;          
          this.predictiveSearchResults.style.setProperty('--max-height', height + 'px');          
          this.setAttribute('open', true);
          this.predictiveSearchResults.setAttribute('aria-expanded', true);
          this.isOpen = true;
          this.querySelector('form.search').classList.add('active');
          if (this.animate) {
            this.animate.classList.add('filter-loaded');
          }
        }
        close(clearSearchTerm = false) {
          if (clearSearchTerm) {
            this.input.value = '';
            this.removeAttribute('results');
          }    
          this.querySelector('form.search').classList.remove('open');
          const selected = this.querySelector('[aria-selected="true"]');
          if (selected) selected.setAttribute('aria-selected', false);
          this.removeAttribute('open');
          this.predictiveSearchResults.setAttribute('aria-expanded', false);
          this.resultsMaxHeight = false;
          this.querySelector('form.search').classList.remove('active');
          this.isOpen = false;
          if (this.animate) {
            var _this = this;                        
            setTimeout(function() {
              _this.animate.classList.remove('filter-loaded');
            }, 250);
          }
          this.classList.remove('focused');          
          this.input.removeEventListener('focus', this.onFocus.bind(this));
          this.removeEventListener('focusout', this.onFocusOut.bind(this));
        }
      }
      customElements.define('predictive-search', PredictiveSearch); 
	};
    document.body.classList.remove('loading');
  }
  return Header;
})();

/* ============================================
   RIBBLE CART DRAWER
   ============================================ */

(function () {
  'use strict';

  // ── Elements ──────────────────────────────
  var drawer   = document.getElementById('ribble-cart-drawer');
  var overlay  = document.getElementById('ribble-cart-overlay');
  var btnClose = document.getElementById('ribble-cart-close');
  var btnContinue = document.getElementById('ribble-cart-continue');
  var btnCheckout = document.getElementById('ribble-cart-checkout');
  var itemsWrap = document.getElementById('ribble-cart-items');

  // ── Global Bag Trigger (Updated to catch Avenue Theme links & SVGs) ──
  document.addEventListener('click', function (e) {
    if (e.target.closest('#ribble-cart-drawer')) return;
    var trigger = e.target.closest('a.relative.keydown-link, a[href="/cart"], [href*="/cart"], .cart-count-mobile, .header-cart, [aria-label*="Bag" i]');
    if (!trigger) return;

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    
    openCartDrawer();
    renderDrawer();
  }, true);

var cartInFlight = false;
var cachedCart = null;
var cartDirty = false;
fetch('/cart.js').then(function(r){return r.json();}).then(function(cart){ cachedCart = cart; });


  // ── Suppress native dropdown ───────────────
  // Override CartDrop to no-op so ATC never opens the dropdown
  if (window.CartDrop) {
    window.CartDrop = function () {
      // Update bag count and total on ATC
      fetch('/cart.js')
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          // Update count
          document.querySelectorAll('.cartCountSelector').forEach(function(el) {
            el.textContent = cart.item_count;
          });
          // Update total
          document.querySelectorAll('.cartTotalSelector').forEach(function(el) {
            el.textContent = '\u00a3' + (cart.total_price / 100).toFixed(2);
          });
                    cachedCart = cart;
          cartDirty = true;
          triggerBagPulse();
          ribbleUpdateDonationBanner();


          // RIBBLE — reward prompt
          var rewardPrompt = document.getElementById('ribble-reward-inline');
          if (rewardPrompt) {
            var optionalHandles = ['longridge-school-fleece', 'longridge-c-of-e-school-fleece'];
            var peHandle = 'longridge-school-pe-t-shirt';
            var totalOptionalQty = cart.items
              .filter(function(i) {
                return (i.properties && (i.properties['_optional'] === 'true' || i.properties['_optional'] === true))
                  || optionalHandles.indexOf(i.handle) > -1;
              })
              .reduce(function(s, i) { return s + i.quantity; }, 0);
            var totalPeTopQty = cart.items
              .filter(function(i) { return i.handle === peHandle; })
              .reduce(function(s, i) { return s + i.quantity; }, 0);
            if (totalOptionalQty > totalPeTopQty) {
              rewardPrompt.style.display = 'flex';
              setTimeout(function() {
                rewardPrompt.classList.add('ribble-reward-inline--visible');
              }, 160);
            }
          }
        });
    };
  }


  // ── Open / Close ──────────────────────────
  function openCartDrawer() {
    try {
      drawer.classList.add('is-open');
      overlay.classList.add('is-open');
      document.body.classList.add('rcd-open');
      history.pushState({ rcdOpen: true }, '');
    } catch (e) {
      window.location.href = window.theme && window.theme.routes_cart_url
        ? window.theme.routes_cart_url
        : '/cart';
    }
  }





  function closeCartDrawer() {
    drawer.classList.remove('is-open');
    overlay.classList.remove('is-open');
    document.body.classList.remove('rcd-open');
  }

  // ── Close triggers ────────────────────────
  if (btnClose)    btnClose.addEventListener('click', closeCartDrawer);
  if (btnContinue) btnContinue.addEventListener('click', closeCartDrawer);
  if (overlay)     overlay.addEventListener('click', closeCartDrawer);

  // Browser back/forward
  window.addEventListener('popstate', function (e) {
    if (drawer.classList.contains('is-open')) {
      closeCartDrawer();
    }
  });

  // Hamburger menu open → close drawer
  var hamburger = document.querySelector('.mobile-nav-toggle, .hamburger, [data-mobile-nav-toggle], .js-mobile-nav-toggle');
  if (hamburger) {
    hamburger.addEventListener('click', function () {
      if (drawer.classList.contains('is-open')) closeCartDrawer();
    });
  }

  // ── Bag icon bounce on ATC ─────────────────
  document.addEventListener('cartItems', function () {
    renderDrawer();
  });

    // ── Qty controls & remove ─────────────────
  document.addEventListener('click', function (e) {
    if (!e.target.closest('#ribble-cart-items')) return;

    var btn = e.target.closest('.rcd-qty-plus, .rcd-qty-minus, .rcd-remove');
    if (!btn) return;

    var item = btn.closest('.rcd-item');
    if (!item) return;

    var key = item.getAttribute('data-key');
    if (!key) return;

    var qtyEl = item.querySelector('.rcd-qty-value');
    var currentQty = qtyEl ? parseInt(qtyEl.textContent, 10) : 1;

    if (btn.classList.contains('rcd-qty-plus')) {
      updateLineItem(key, currentQty + 1);
    } else if (btn.classList.contains('rcd-qty-minus')) {
      updateLineItem(key, Math.max(currentQty - 1, 0));
    } else if (btn.classList.contains('rcd-remove')) {
      updateLineItem(key, 0);
    }
  });


  function syncFreeWithProperties(cart, callback) {
    // Triggers: items with _optional = true
    var triggerItems = cart.items.filter(function(i) {
      return i.properties && i.properties['_optional'] === 'true';
    });

    // Collect all reward handles from trigger items' _trigger_reward property
    var rewardHandles = [];
    triggerItems.forEach(function(i) {
var h = i.properties && (i.properties['_trigger_reward'] || i.properties['_reward_handle']);
      if (h && rewardHandles.indexOf(h) === -1) rewardHandles.push(h);
    });

    // Reward items: any cart item whose handle matches a reward handle
    var rewardItems = cart.items.filter(function(i) {
      return rewardHandles.indexOf(i.handle) !== -1;
    });

    var totalTriggerQty = triggerItems.reduce(function(sum, i) { return sum + i.quantity; }, 0);
    var triggerName = triggerItems.length > 0 ? (triggerItems[0].product_title || '') : '';

    // Assign free slots to reward items in order
    var slotsRemaining = totalTriggerQty;
    var toMark  = [];
    var toStrip = [];

    rewardItems.forEach(function(item) {
      var alreadyFree = !!item.properties['_free_with'];

      if (slotsRemaining >= item.quantity) {
        if (!alreadyFree) toMark.push({ item: item, triggerName: triggerName });
        slotsRemaining -= item.quantity;
      } else if (slotsRemaining > 0) {
        if (!alreadyFree) toMark.push({ item: item, triggerName: triggerName });
        slotsRemaining = 0;
      } else {
        if (alreadyFree) toStrip.push(item);
      }
    });

    // Strip _free_with from non-reward items that somehow have it
    cart.items.forEach(function(i) {
      if (i.properties && i.properties['_free_with'] && rewardHandles.indexOf(i.handle) === -1) {
        toStrip.push(i);
      }
    });

    var ops = [];

    toMark.forEach(function(entry) {
      var newProps = Object.assign({}, entry.item.properties);
      newProps['_free_with'] = entry.triggerName;
      ops.push(fetch('/cart/change.js', {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({ id: entry.item.key, quantity: entry.item.quantity, properties: newProps })
      }).then(function(r) { return r.json(); }));
    });

    toStrip.forEach(function(item) {
      var newProps = Object.assign({}, item.properties);
      delete newProps['_free_with'];
      ops.push(fetch('/cart/change.js', {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({ id: item.key, quantity: item.quantity, properties: newProps })
      }).then(function(r) { return r.json(); }));
    });

    if (ops.length === 0) {
      callback(cart);
      return;
    }

    Promise.all(ops)
      .then(function() {
        return fetch('/cart.js').then(function(r) { return r.json(); });
      })
      .then(function(freshCart) {
        callback(freshCart);
      })
      .catch(function() {
        callback(cart);
      });
  }


function ribbleUpdateDonationBanner() {
  var banner = document.getElementById('ribble-support-banner');
  if (!banner) return;
  fetch('/cart.js')
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      var supportAmt = cart.items.reduce(function(sum, i) {
  var entry = window.ribbleDonationMap && window.ribbleDonationMap[i.handle];
  var donation = entry ? parseFloat(entry.donation || entry) : 0;
  return sum + (donation * i.quantity);
}, 0);
var amountEl = document.getElementById('ribble-support-amount');
if (supportAmt > 0) {
  banner.style.display = '';
  var schoolName = 'your school';
  cart.items.some(function(i) {
    var entry = window.ribbleDonationMap && window.ribbleDonationMap[i.handle];
    if (entry && entry.school) { schoolName = entry.school; return true; }
    return false;
  });
  var supportPence = Math.round(supportAmt * 100);
  var pounds = Math.floor(supportPence / 100);
  var pence = supportPence % 100;
  var amountStr = '£' + pounds + '.' + (pence < 10 ? '0' : '') + pence + ' School Support';
if (amountEl) {
  var amountValEl = amountEl.querySelector('#ribble-support-amount-value');
  var schoolNameEl = amountEl.querySelector('#ribble-support-school-name');
  if (amountValEl) amountValEl.textContent = amountStr;
  if (schoolNameEl && schoolNameEl.textContent !== 'to ' + schoolName + '.') {
    schoolNameEl.textContent = 'to ' + schoolName + '.';
  }
}

  var subtextEl = banner.querySelector('.school-support-banner__subtext');
  var headingEl = banner.querySelector('.school-support-banner__heading');
  if (subtextEl) subtextEl.style.display = 'none';
  if (headingEl) headingEl.style.display = 'none';
} else {
  banner.style.display = 'none';
}


    })
    .catch(function(err) {
      console.warn('[Ribble] Donation banner update failed:', err);
    });
}



  function updateLineItem(key, qty) {
    if (cartInFlight) return;
    setCheckoutDisabled(true);
    cartInFlight = true;

    fetch('/cart/change.js', {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({ id: key, quantity: qty })
    })
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      return new Promise(function(resolve) {
        syncFreeWithProperties(cart, function(freshCart) {
          resolve(freshCart);
        });
      });
    })
        .then(function(cart) {
      cachedCart = cart;
      renderDrawerFromCart(cart);
      ribbleUpdateDonationBanner(cart);
      document.querySelectorAll('.cartCountSelector').forEach(function(el) {
        el.textContent = cart.item_count;
      });

      document.querySelectorAll('.cartTotalSelector').forEach(function(el) {
        el.textContent = '\u00a3' + (cart.total_price / 100).toFixed(2);
      });
    })
    .catch(function() {
      window.location.href = '/cart';
    })
    .finally(function() {
      cartInFlight = false;
      setCheckoutDisabled(false);
    });
  }


  // ── Render drawer from cart JSON ──────────
    function renderDrawer() {
    if (cachedCart) {
      var existingItems = itemsWrap ? itemsWrap.querySelectorAll('.rcd-item').length : 0;
      if (existingItems === 0 || cartDirty) {
        cartDirty = false;
        renderDrawerFromCart(cachedCart, true);
      }
      ribbleUpdateDonationBanner();
      return;
    }
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        return new Promise(function(resolve) {
          syncFreeWithProperties(cart, function(freshCart) {
            resolve(freshCart);
          });
        });
      })
      .then(function(cart) {
        cachedCart = cart;
        renderDrawerFromCart(cart, true);
        ribbleUpdateDonationBanner();
      })
      .catch(function() {});
  }




    function renderDrawerFromCart(cart, suppressClose) {
    if (!itemsWrap) return;

        if (!cart.item_count || cart.item_count === 0) {
      if (!suppressClose) {
        closeCartDrawer();
        setTimeout(function() {
          itemsWrap.innerHTML = '<div class="rcd-empty"><h1 class="ribble-cart-empty__heading">Your bag is empty.</h1></div>';
        }, 350);
      } else {
        itemsWrap.innerHTML = '<div class="rcd-empty"><h1 class="ribble-cart-empty__heading">Your bag is empty.</h1></div>';
      }

      var sub = document.getElementById('ribble-cart-subtotal');
      var ban = document.getElementById('ribble-support-banner');
      if (sub) sub.style.display = 'none';
      if (ban) ban.style.display = 'none';
      if (btnCheckout) btnCheckout.style.display = 'none';
      return;
    }


    var sub = document.getElementById('ribble-cart-subtotal');
    var ban = document.getElementById('ribble-support-banner');
    if (sub) sub.style.display = '';
    if (ban) ban.style.display = '';
    if (btnCheckout) btnCheckout.style.display = '';

    if (sub) {
      sub.querySelector('.rcd-subtotal-value').textContent = formatMoney(cart.total_price);
    }

        if (ban) {
  var supportAmt = cart.items.reduce(function(sum, i) {
    var entry = window.ribbleDonationMap && window.ribbleDonationMap[i.handle];
    var donation = entry ? parseFloat(entry.donation || entry) : 0;
    return sum + (donation * i.quantity);
  }, 0);

  var schoolName = 'your school';
  cart.items.some(function(i) {
    var entry = window.ribbleDonationMap && window.ribbleDonationMap[i.handle];
    if (entry && entry.school) { schoolName = entry.school; return true; }
    return false;
  });


  var supportPence = Math.round(supportAmt * 100);
  var amountStr;
  if (supportPence >= 100) {
  var pounds = Math.floor(supportPence / 100);
  var pence = supportPence % 100;
  amountStr = '£' + pounds + '.' + (pence < 10 ? '0' : '') + pence + ' School Support';
} else {
  amountStr = supportPence + 'p School Support';
}

var amountEl = ban.querySelector('.school-support-banner__amount');
var subtextEl = ban.querySelector('.school-support-banner__subtext');
var headingEl = ban.querySelector('.school-support-banner__heading');

if (amountEl) amountEl.innerHTML = amountStr + '<br><span style="font-size:12px;font-weight:400;opacity:0.9;display:block;text-align:center;">' + 'to ' + schoolName + '.</span>';
if (subtextEl) subtextEl.style.display = 'none';
if (headingEl) headingEl.style.display = 'none';


}




        // ── PE Top free slot logic ─────────────────
        var optionalHandles = ['longridge-school-fleece', 'longridge-c-of-e-school-fleece'];
    var peTopTriggers = cart.items.filter(function(i) {
      return (i.properties && i.properties['_optional'] === 'true') || optionalHandles.indexOf(i.handle) > -1;
    });


    var rewardHandles = [];
    peTopTriggers.forEach(function(i) {
var h = i.properties && (i.properties['_trigger_reward'] || i.properties['_reward_handle']);
      if (h && rewardHandles.indexOf(h) === -1) rewardHandles.push(h);
    });

    var totalTriggerQty = peTopTriggers.reduce(function(sum, i) { return sum + i.quantity; }, 0);
    var triggerName = peTopTriggers.length > 0 ? (peTopTriggers[0].product_title || 'your fleece') : 'your fleece';
    var fleecesLabel = totalTriggerQty === 1 ? 'your fleece' : 'your ' + totalTriggerQty + ' fleeces';

    // Build free slot map keyed by item.key
    var rewards = cart.items.filter(function(i) {
  return rewardHandles.indexOf(i.handle) !== -1;
});
rewards.sort(function(a, b) {
  var aMatch = a.quantity === totalTriggerQty ? 0 : 1;
  var bMatch = b.quantity === totalTriggerQty ? 0 : 1;
  return aMatch - bMatch;
});
var slotsLeft = totalTriggerQty;

    var freeMap = {};
    rewards.forEach(function(item) {
      if (slotsLeft >= item.quantity) {
        freeMap[item.key] = true;
        slotsLeft -= item.quantity;
      } else if (slotsLeft > 0) {
        freeMap[item.key] = true;
        slotsLeft = 0;
      } else {
        freeMap[item.key] = false;
      }
    });

    // Remaining unclaimed slots for trigger SVG badge
    var remainingSlots = slotsLeft;
var ghostSlots = slotsLeft; 
    var html = '';

    var sortedItems = cart.items.slice().sort(function(a, b) {
  var aIsFreeReward = rewardHandles.indexOf(a.handle) !== -1 && !!freeMap[a.key];
  var bIsFreeReward = rewardHandles.indexOf(b.handle) !== -1 && !!freeMap[b.key];
  if (aIsFreeReward && !bIsFreeReward) return -1;
  if (bIsFreeReward && !aIsFreeReward) return 1;
  return 0;
});

    sortedItems.forEach(function(item) {

  var variantHtml = (item.variant_title && item.variant_title !== 'Default Title')
    ? '<div class="rcd-item-variant">' + escHtml(item.variant_title) + '</div>'
    : '';
  var imgHtml = item.image
    ? '<img src="' + item.image.replace(/(\.\w+)$/, '_80x80_crop_center$1') + '" alt="' + escHtml(item.title) + '" width="80" height="80" loading="lazy">'
    : '';

  var schoolName = item.properties && item.properties['_school_name'] ? item.properties['_school_name'] : '';
  var shortName  = item.properties && item.properties['_short_name']  ? item.properties['_short_name']  : '';

  var optionalHandles = ['longridge-school-fleece', 'longridge-c-of-e-school-fleece'];
  var isOptional = (item.properties && item.properties['_optional'] === 'true') || optionalHandles.indexOf(item.handle) > -1;
  var isReward   = rewardHandles.indexOf(item.handle) !== -1;
  var isFreeItem = !!freeMap[item.key];

  var lineSlots  = isOptional ? Math.min(item.quantity, Math.max(0, remainingSlots)) : 0;
  var hasFreeTop = isOptional && lineSlots > 0;
  if (isOptional) remainingSlots = Math.max(0, remainingSlots - item.quantity);

  var peTopLabel = lineSlots === 1
    ? 'Select your free PE top'
    : 'Select ' + lineSlots + ' free PE tops';

  var calloutText = item.properties && item.properties['_callout_text']
    ? item.properties['_callout_text']
    : 'Optional Item';

  var svgIcon = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16" fill="#33CC66"><path d="M21.41 11.58l-9-9A2 2 0 0 0 11 2H4a2 2 0 0 0-2 2v7a2 2 0 0 0 .59 1.42l9 9A2 2 0 0 0 13 22a2 2 0 0 0 1.41-.59l7-7A2 2 0 0 0 21.41 11.58zM6.5 8A1.5 1.5 0 1 1 8 6.5 1.5 1.5 0 0 1 6.5 8z"/></svg>';

  var titleHtml;
if (schoolName && shortName) {
  titleHtml = '<span class="ribble-school-name">' + escHtml(schoolName) + '</span><br><span class="ribble-short-name">' + escHtml(shortName) + '</span>';
} else {
  titleHtml = escHtml(item.product_title || item.title);
}
/* OPTIONAL BADGE — commented out, handled by ghost line instead
if (isOptional && hasFreeTop) {
  titleHtml += '<span class="rcd-pe-badge" style="display:inline-flex;align-items:center;gap:6px;margin-left:6px;vertical-align:middle;cursor:pointer;position:relative;">'
    + svgIcon
    + '<span class="rcd-pe-tooltip" style="padding:5px 8px;top:100%;bottom:auto;left:50%;transform:translateX(-50%);white-space:normal;width:160px;text-align:center;line-height:1.3;font-size:11px;">' + escHtml(calloutText) + '</span>'
    + '</span>';
}
*/




  var priceCellHtml;
  if (isFreeItem) {
    priceCellHtml = '<div class="rcd-item-price">'
      + '<span class="rcd-free-label" style="font-weight:700;color:#33CC66;">Free</span>'
      /* + '<span class="rcd-pe-badge">'
      + '<span style="color:#000;font-weight:900;cursor:default;font-size:14px;">ⓘ</span>'
      + '<span class="rcd-pe-tooltip">Included free with ' + escHtml(fleecesLabel) + '</span>'
      + '</span>' */
      + '</div>';

  } else if (isOptional) {
    priceCellHtml = '<div class="rcd-item-price">' + formatMoney(item.final_line_price) + '</div>';
  } else if (isReward && !isFreeItem) {
    priceCellHtml = '<div class="rcd-item-price">' + formatMoney(item.original_line_price) + '</div>';
  } else {
    priceCellHtml = '<div class="rcd-item-price">' + formatMoney(item.final_line_price) + '</div>';
  }

html += '<div class="rcd-item" data-key="' + item.key + '" style="border-bottom:1px solid #e5e5e5;">'
    + '<div class="rcd-item-image">' + imgHtml + '</div>'
    + '<div class="rcd-item-details">'
+   '<div class="rcd-item-title"><a href="' + item.url + '">' + titleHtml + '</a></div>'

    +   variantHtml
    +   '<div class="rcd-item-controls">'
    +     '<div class="rcd-qty">'
    +       '<button class="rcd-qty-btn rcd-qty-minus" data-key="' + item.key + '" aria-label="Decrease quantity">−</button>'
    +       '<span class="rcd-qty-value">' + item.quantity + '</span>'
    +       '<button class="rcd-qty-btn rcd-qty-plus" data-key="' + item.key + '" aria-label="Increase quantity">+</button>'
    +     '</div>'
    +     '<button class="rcd-remove" data-key="' + item.key + '" aria-label="Remove item">Remove</button>'
    +   '</div>'
    + '</div>'
    + priceCellHtml
    + '</div>';
});

itemsWrap.innerHTML = html;




    // Update ghost line
    var ghostLine = document.getElementById('ribble-pe-ghost-line');
    if (ghostLine) {
      if (ghostSlots > 0) {
        var ghostCount = document.getElementById('ribble-pe-ghost-count');
        var ghostPlural = document.getElementById('ribble-pe-ghost-plural');
        if (ghostCount) ghostCount.textContent = ghostSlots;
        if (ghostPlural) ghostPlural.textContent = ghostSlots === 1 ? '' : 's';
        ghostLine.style.display = 'block';
      } else {
                ghostLine.style.display = 'none';
      }
    }
  }







  // ── Checkout button ───────────────────────
  if (btnCheckout) {
    btnCheckout.addEventListener('click', function(e) {
      e.preventDefault();
      if (typeof ribbleTermsOpen === 'function') {
        ribbleTermsOpen();
      } else {
        window.location.href = '/checkout';
      }
    });
  }

  function setCheckoutDisabled(state) {
    if (!btnCheckout) return;
    btnCheckout.disabled = state;
    btnCheckout.classList.toggle('is-loading', state);
  }


  // ── Helpers ───────────────────────────────
  function formatMoney(cents) {
    var pounds = (cents / 100).toFixed(2);
    return '\u00a3' + pounds;
  }

  function escHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

})();

// FREE PE TOP — inject _free_with property on ATC
if (window.location.search.includes('ref=pe-free')) {
  fetch('/cart.js')
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      var optionalItem = cart.items.find(function(i) {
        return i.properties && i.properties['_optional'] === 'true';
      });
      if (optionalItem) {
        var form = document.querySelector('form[action="/cart/add"]');
        if (form) {
          var input = document.createElement('input');
          input.type = 'hidden';
          input.name = 'properties[_free_with]';
          input.value = optionalItem.product_title;
          form.appendChild(input);
          
        }
      }
    });
}

// Mobile product image first-tap fix
document.addEventListener('touchstart', function(e) {
  var link = e.target.closest('a.product-thumb-main');
  if (!link) return;
  link._touchStarted = true;
}, { passive: true });

document.addEventListener('touchend', function(e) {
  var link = e.target.closest('a.product-thumb-main');
  if (!link || !link._touchStarted) return;
  link._touchStarted = false;
  e.preventDefault();
  window.location.href = link.href;
}, { passive: false });



